import { memo } from 'react';

interface IShoppingBagIconProps {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const ShoppingBagIcon: React.FC<IShoppingBagIconProps> = memo(
  ({ className = '', width = 24, height = 24, color = 'currentColor' }) => (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M21.2958 7.40731H17.2217V6.85175C17.2206 5.45079 16.6727 4.10558 15.6946 3.10253C14.7166 2.09948 13.3856 1.51782 11.9851 1.48138H11.7175C10.317 1.51782 8.98606 2.09948 8.008 3.10253C7.02994 4.10558 6.48203 5.45079 6.48094 6.85175V7.40731H2.40686C2.35775 7.40731 2.31065 7.42682 2.27592 7.46155C2.24119 7.49628 2.22168 7.54338 2.22168 7.59249V21.4814C2.22168 21.6778 2.29972 21.8663 2.43864 22.0052C2.57755 22.1441 2.76596 22.2221 2.96242 22.2221H20.7402C20.9367 22.2221 21.1251 22.1441 21.264 22.0052C21.4029 21.8663 21.4809 21.6778 21.4809 21.4814V7.59249C21.4809 7.54338 21.4614 7.49628 21.4267 7.46155C21.392 7.42682 21.3449 7.40731 21.2958 7.40731ZM8.33279 6.89805C8.33279 4.96101 9.87955 3.35361 11.8166 3.33324C12.2814 3.32914 12.7425 3.4171 13.1732 3.59204C13.6038 3.76699 13.9956 4.02545 14.3259 4.35254C14.6562 4.67962 14.9185 5.06885 15.0977 5.49779C15.2769 5.92674 15.3694 6.3869 15.3698 6.85175V7.40731H8.33279V6.89805ZM17.0365 11.111C17.0365 12.4862 16.4902 13.8051 15.5178 14.7775C14.5454 15.7499 13.2265 16.2962 11.8513 16.2962C10.4761 16.2962 9.15724 15.7499 8.18483 14.7775C7.21242 13.8051 6.66612 12.4862 6.66612 11.111V9.62953H8.14761V11.111C8.14761 12.0933 8.53782 13.0353 9.2324 13.7299C9.92697 14.4245 10.869 14.8147 11.8513 14.8147C12.8336 14.8147 13.7756 14.4245 14.4702 13.7299C15.1648 13.0353 15.555 12.0933 15.555 11.111V9.62953H17.0365V11.111Z"
        fill={color}
      />
    </svg>
  ),
);

ShoppingBagIcon.displayName = 'ShoppingBagIcon';

export { ShoppingBagIcon };
